var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('filter-search',{attrs:{"exportTemplate":"BoardManage","filename":"经营分析"},on:{"search":_vm.search}}),_vm._v(" "),_c('business-table',{attrs:{"tableData":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }